module.exports = __webpack_public_path__ + "static/img/gaojing.7fab88f5.png";